import React, { ChangeEvent } from "react";

type Props = {
  indeterminate?: boolean;
  onChange?: (e: ChangeEvent) => void;
  style?: React.CSSProperties;
  checked?: boolean;
  rounded?: boolean;
  colorVariant?: "default" | "alternate";
};

export default function IndeterminateCheckbox({
  indeterminate = false,
  onChange,
  style = {},
  checked = false,
  rounded = false,
  colorVariant = "default",
}: Props) {
  const color = colorVariant === "default" ? "#E38006" : "#006AF5";

  const thisOnClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    if (onChange !== undefined) {
      onChange({ ...e, target: e.currentTarget });
    }
  };

  return (
    <svg
      onClick={thisOnClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        cursor: "pointer",
        ...style,
      }}
    >
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx={rounded ? 4 : 0}
        fill={checked ? color : "#FFFFFF"}
        stroke="#303030"
      />
      {indeterminate ? (
        <rect x="4" y="4" width="16" height="16" fill={color} stroke={color} />
      ) : (
        <path d="M3 13L5 11L9 15L19 5L21 7L9 19L3 13Z" fill="white" />
      )}
    </svg>
  );
}
